/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import * as React from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import Text from '@/wpt-lib/pdf/common/Text';

const Footer: React.VFC = () => {
    return (
        <View style={styles.footer} fixed>
            <Text
                render={({ pageNumber, totalPages }: { pageNumber: number; totalPages: number }) =>
                    `${pageNumber} / ${totalPages}`
                }
            />
        </View>
    );
};

const styles = StyleSheet.create({
    footer: {
        paddingHorizontal: 28,
        paddingVertical: 20,
        width: '100%',
        height: 20,
        flexDirection: 'row',
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
    },
});

export default Footer;
